import {
  MFA_SELECTOR_TOTP_DESCRIPTION,
  MFA_SELECTOR_WEB_AUTHN_DESCRIPTION,
  MFA_SETTINGS_TITLE,
  MFA_TOTP_NAME,
  MFA_WEB_AUTHN_NAME,
} from './ui.labels'

export const RECOVERY_OTP = 'RECOVERY_OTP'
export const TOTP = 'TOTP'
export const WEB_AUTHN = 'WEB_AUTHN'

export const MFATypes = {
  RECOVERY_OTP,
  TOTP,
  WEB_AUTHN,
}

export const Properties = {
  [RECOVERY_OTP]: {
    name: MFA_SETTINGS_TITLE,
  },
  [WEB_AUTHN]: {
    name: MFA_WEB_AUTHN_NAME,
    icon: 'security_key',
    color: 'blue',
  },
  [TOTP]: {
    name: MFA_TOTP_NAME,
    icon: 'phonelink_lock',
    color: 'green',
  },
}

export const AvailableMFA = {
  [WEB_AUTHN]: {
    ...Properties[WEB_AUTHN],
    description: MFA_SELECTOR_WEB_AUTHN_DESCRIPTION,
  },
  [TOTP]: {
    ...Properties[TOTP],
    description: MFA_SELECTOR_TOTP_DESCRIPTION,
  },
}
